import { z } from 'zod';

export const PlayerPackFormSchema = z.object({
  title: z.string().min(1, {
    message: 'Title is required.'
  }),
  image: z.any().refine((file) => file instanceof File, {
    message: 'Image is required.'
  }),
  placeByTime: z.string().refine(
    (val) => {
      const selectedDate = new Date(val);
      const now = new Date();
      return selectedDate > now;
    },
    {
      message: 'Date and time must be in the future.'
    }
  ),
  canFade: z.boolean(),
  excludedStates: z.array(z.string()).optional(),
  picks: z
    .array(
      z.object({
        wagerType: z.string().min(1),
        projectionId: z.string().min(1)
      })
    )
    .min(1)
    .refine((picks) => picks.every((p) => p.wagerType && p.projectionId))
});

export type PlayerPackFormValues = z.infer<typeof PlayerPackFormSchema>;
